import { Routes } from "@angular/router";

export const overviewRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./pages/overview/overview.component").then((c) => c.OverviewComponent),
  },
];
